module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./UserRestrictions.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/components/UserRestrictions.js
// module id = 2001
// module chunks = 4